import { useMemo } from 'react';
import { Layer, Shape } from 'react-konva';
import type Konva from 'konva';

// ------------------------------------------------------------
// Konva grid drawn in layout world coordinates (pans/zooms with stage).
// ------------------------------------------------------------

interface LayoutGridLayerProps {
  width: number;
  height: number;
  cellSize: number;
  visible: boolean;
}

function drawGrid(
  context: Konva.Context,
  shape: Konva.Shape,
  width: number,
  height: number,
  cellSize: number,
) {
  const step = Math.max(1, cellSize);
  context.beginPath();
  context.strokeStyle = 'rgba(135, 135, 134, 0.28)';
  context.lineWidth = 1;

  for (let x = 0; x <= width; x += step) {
    context.moveTo(x + 0.5, 0);
    context.lineTo(x + 0.5, height);
  }
  for (let y = 0; y <= height; y += step) {
    context.moveTo(0, y + 0.5);
    context.lineTo(width, y + 0.5);
  }
  context.stroke();
  context.fillStrokeShape(shape);
}

export default function LayoutGridLayer({
  width,
  height,
  cellSize,
  visible,
}: LayoutGridLayerProps) {
  const sceneFunc = useMemo(
    () => (context: Konva.Context, shape: Konva.Shape) => {
      drawGrid(context, shape, width, height, cellSize);
    },
    [width, height, cellSize],
  );

  if (!visible || width <= 0 || height <= 0) return null;

  return (
    <Layer
      listening={false}
      clipX={0}
      clipY={0}
      clipWidth={width}
      clipHeight={height}
    >
      <Shape sceneFunc={sceneFunc} />
    </Layer>
  );
}
